// Keep track of all wavesurfer instances and currently playing instance
let wavesurferInstances = [];
let currentlyPlaying = null;

document.addEventListener('DOMContentLoaded', function () {
  // Find all waveform containers
  var waveforms = document.querySelectorAll('.waveform');

  // Loop through each waveform container and initialize WaveSurfer
  waveforms.forEach(function (waveformContainer, index) {
    // Get the audio URL from the data attribute
    var audioUrl = waveformContainer.getAttribute('data-audio-url');

    // Create a unique ID for the waveform container if not already set
    if (!waveformContainer.id) {
      waveformContainer.id = 'waveform-' + index;
    }


    // Create a WaveSurfer instance for this container
    var wavesurfer = WaveSurfer.create({
      container: '#' + waveformContainer.id,
      waveColor: '#cccccc',
      progressColor: '#D500FF',
      height: 80,
      width: "90%",
      cursorWidth: 0,
      responsive: true,
      backend: 'MediaElement',
      
    });

    // Load the audio file
    wavesurfer.load(audioUrl);

    // Find the play/pause button inside the current waveform container
    var playPauseButton = waveformContainer.querySelector('.play-pause');
    
    // Set play/pause button icons
    const playIcon = '<i class="fas fa-play"></i>';
    const pauseIcon = '<i class="fas fa-pause"></i>';

    // Set initial icon to play
    playPauseButton.innerHTML = playIcon;

    // Add event listener to the play/pause button
    playPauseButton.addEventListener('click', function () {
      // If there's a currently playing instance and it's not this one, stop it
      if (currentlyPlaying && currentlyPlaying !== wavesurfer) {
        currentlyPlaying.pause();
        // Find and update the play button for the previously playing instance
        waveforms.forEach(function (container) {
          if (container.querySelector('.waveform') === currentlyPlaying.container) {
            container.querySelector('.play-pause').innerHTML = '<i class="fa fa-play"></i>';
          }
        });
      }
      
      if (wavesurfer.isPlaying()) {
        wavesurfer.pause();
        playPauseButton.innerHTML = playIcon;
        currentlyPlaying = null;
      } else {
        wavesurfer.play();
        playPauseButton.innerHTML = pauseIcon;
        currentlyPlaying = wavesurfer;
      }
    });

    // Update the button to pause when the audio starts playing
    wavesurfer.on('play', function () {
      playPauseButton.innerHTML = pauseIcon;
    });

    // Reset to play icon when audio is paused
    wavesurfer.on('pause', function () {
      playPauseButton.innerHTML = playIcon;
    });

    // Update play button when playback finishes
    wavesurfer.on('finish', function() {
      playPauseButton.innerHTML = playIcon;
      currentlyPlaying = null;
    });

    // Add instance to our array
    wavesurferInstances.push(wavesurfer);
  });
});
